window.onload = function() {
  // console.log("gen running...");

  /*************/
  /* Home Page */
  /*************/

  /****************/
  /* Main Product */
  /****************/
  /*********************/
  /* .ver-main-product */
  /*********************/
  /* Buy button */
  var add_to_bag_btn = document.querySelector('.ver-main-product .product-form');
  if (add_to_bag_btn) {
    var parent_div = add_to_bag_btn.parentElement;
    parent_div.setAttribute("id", "ver-add-btn");
  }

  /* .ver-product-type-bundles */
  const add_bundle_button = document.querySelector('.ver-product-type-bundles #ver-add-btn');
  if (add_bundle_button) {
    add_bundle_button.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const main_bundle_product = document.querySelector('.ver-product-type-bundles');
      const subvariantid1 = Number(main_bundle_product.dataset.subvariantId1);
      const subvariantid2 = Number(main_bundle_product.dataset.subvariantId2);

      const item_quantity_input = document.querySelector('.ver-main-product .quantity__input');
      const item_quantity = Number(item_quantity_input.value);
      let cart_drawer = document.querySelector('cart-drawer');
      let formData = {
        'items': [{
        'id': subvariantid2,
        'quantity': item_quantity
        },
        {
        'id': subvariantid1,
        'quantity': item_quantity
        }],
        sections: cart_drawer.getSectionsToRender().map(section => section.id),
        sections_url: window.location.pathname
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(parsed_response => {
        if (parsed_response.status) {
          console.error('Cart add error:', parsed_response.description || parsed_response.message);
          return;
        }

        if (cart_drawer && parsed_response.sections && typeof cart_drawer.renderContents === 'function') {
          cart_drawer.renderContents(parsed_response);
          cart_drawer.classList.remove('is-empty');
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }, true);
  }

  /* Accordion */
  var accordions = document.querySelectorAll('.ver-main-product .product__accordion');
  if (accordions) {
    var first_accordion = accordions[0]; 
    var last_accordion = accordions[accordions.length - 1];

    if (first_accordion) {
      first_accordion.setAttribute("id", "ver-first-accord");
    }
    if (last_accordion) {
      last_accordion.setAttribute("id", "ver-last-accord");
    }
  }
}